<form
	[formGroup]="controller.addUserNoteForm"
	(submit)="onSubmitAddUserNoteClick()"
	class="flex items-stretch flex-col space-y-3"
>
	<div class="flex flex-col space-y-1 items-stretch">
		<label [title]="controller.i18n + '.note.label' | translate" class="truncate">
			{{ controller.i18n + '.note.label' | translate }}
		</label>
		<textarea
			class="mb-6"
			formControlName="note"
			pInputTextarea
			rows="8"
		></textarea>
	</div>
	<button
		[disabled]="controller.isAddUserNoteFormInvalid$ | async"
		[label]="controller.i18n + '.submitButton.label' | translate"
		pButton
		type="submit"
	></button>
</form>
